// Template Dashboard 2 MUI components
import TemplateBox from "components/TemplateBox";
import TemplateTypography from "components/TemplateTypography";
import TemplateButton from "components/TemplateButton";
import PropTypes from "prop-types";

// Authentication layout components
import { Box, Card, Grid } from "@mui/material";

// Image
import logoImage from "assets/images/logos/LOGO-EptaService-blackAndWhite_3D_CMYK.png";
import prog from "assets/images/logos/prog.png";

import shiny from "assets/images/ShinyOverlay.png";

import "assets/css/signIn.css";

function SSOSignIn({ ssoSignIn }) {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${shiny})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Card
        style={{
          width: "100%",
          maxWidth: "1100px",
          height: "auto",
          display: "flex",
          flexDirection: "column",
          margin: "auto",
          boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.25)",
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sm={6}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "1rem",
            }}
          >
            <Box textAlign="center" mb={3} mt={4}>
              <img
                src={logoImage}
                alt="Logo"
                style={{
                  maxWidth: "120px",
                  maxHeight: "120px",
                  marginBottom: "2rem",
                }}
              />
            </Box>
            <TemplateBox textAlign="center">
              <TemplateTypography
                variant="h3"
                fontWeight="bold"
                mb={4}
                color="signInText"
              >
                Welcome to EptaService GAM
              </TemplateTypography>
              <TemplateTypography
                variant="h6"
                fontWeight="bold"
                color="#d77900"
              >
                Sign in with your Azure account
              </TemplateTypography>
            </TemplateBox>
            <TemplateBox mb={8} textAlign="center" />
            <Box style={{ marginTop: "auto", marginBottom: "auto" }} />
            <TemplateBox mt={1} mb={18} textAlign="center" alignSelf="center">
              <TemplateButton
                onClick={() => ssoSignIn()}
                color="signInButton"
                size="large"
              >
                Sign In
              </TemplateButton>
            </TemplateBox>
            <Box sx={{ flex: 2 }} />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            style={{
              backgroundImage: `url(${prog})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            {/* L'immagine si adatterà automaticamente a questa metà della card */}
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}

SSOSignIn.propTypes = {
  ssoSignIn: PropTypes.func.isRequired,
};

export default SSOSignIn;
